import { InputValidator } from "../../modules/enums";

export const NUMBER_REGEX = new RegExp(/.*\d/);
export const LENGTH_REGEX = new RegExp(/.{8,}$/);
export const LOWERCASE_REGEX = new RegExp(/.*[a-z]/);
export const UPPERCASE_REGEX = new RegExp(/.*[A-Z]/);
export const SPECIAL_CHARS_REGEX = new RegExp(/.*[-’/`~!#*$@_%+=.,^&(){}[\]|;:”<>?\\]/);

export const emailValidator = (email: string): { validState: InputValidator, validEmail: string } => {
	const sanitized = email.toLowerCase().trim();
	const pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/ 
	const validState = pattern.test(sanitized) ? InputValidator.VALID : InputValidator.INVALID;
	return { validState, validEmail: sanitized }
};

export const phoneValidator = (phone: string) => {
	const pattern = /^[+]?[(]?[0-9]{3}[)]?[-\]?[0-9]{3}[-\s]?[0-9]{4,7}$/;
	return pattern.test(phone)
}